
// COMPONENTS
import sample_component from './sample-component/sample-component.js';

export default [
	sample_component
];
